const FeaturedIconWarning = (props) => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.3">
      <path
        d="M6.5 19C6.5 11.8203 12.3203 6 19.5 6C26.6797 6 32.5 11.8203 32.5 19C32.5 26.1797 26.6797 32 19.5 32C12.3203 32 6.5 26.1797 6.5 19Z"
        stroke="#F2994A"
        stroke-width="2"
      />
    </g>
    <g opacity="0.1">
      <path
        d="M1.5 19C1.5 9.05888 9.55888 1 19.5 1C29.4411 1 37.5 9.05888 37.5 19C37.5 28.9411 29.4411 37 19.5 37C9.55888 37 1.5 28.9411 1.5 19Z"
        stroke="#F2994A"
        stroke-width="2"
      />
    </g>
    <g clip-path="url(#clip0_6874_10110)">
      <path
        d="M19.5003 27.3334C24.1027 27.3334 27.8337 23.6025 27.8337 19.0001C27.8337 14.3977 24.1027 10.6667 19.5003 10.6667C14.898 10.6667 11.167 14.3977 11.167 19.0001C11.167 23.6025 14.898 27.3334 19.5003 27.3334Z"
        stroke="#F2994A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 22.3333V19"
        stroke="#F2994A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 15.6667H19.5083"
        stroke="#F2994A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6874_10110">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(9.5 9)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FeaturedIconWarning;
